<template>
    <v-container>
        <v-card>
            <v-card-title>
                Criar Usuario

                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>

                <v-btn
                    color="indigo darken-1"
                    dark
                    fab
                    small
                    :to="{name: 'user.read'}"
                >
                    <v-icon>
                        mdi-arrow-left
                    </v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-alert
                    v-model="alert.show"
                    dismissible
                    :color="alert.type"
                    border="left"
                    elevation="2"
                    colored-border
                    transition="scale-transition"
                >
                    {{alert.text}}
                </v-alert>

                <v-alert
                    v-model="alertSuccess.show"
                    dismissible
                    :color="alert.type"
                    border="left"
                    elevation="2"
                    colored-border
                    transition="scale-transition"
                >
                    {{alertSuccess.text}}
                </v-alert>

                <v-form ref="form" >
                    <v-row>
                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-text-field
                                label="Nome"
                                v-model="form.login"
                                counter
                                maxlength="16"
                                :rules="[
                                    form_login_rules.required, form_login_rules.counter,
                                        form_login_rules.min
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-text-field
                                label="Senha"
                                v-model="form.senha"
                                maxlength="16"
                                hint="Pelo menos 8 caracteres"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                                :rules="[
                                    form_senha_rules.required, form_senha_rules.min
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-text-field
                                label="Email de Recuperação"
                                v-model="form.email_recuperacao"
                                maxlength="64"
                                :rules="[
                                    form_email_rules.required, form_email_rules.counter,
                                        form_email_rules.email
                                ]"
                            ></v-text-field>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-autocomplete
                                label="Tipo de Usuario"
                                v-model="form.id_tipo_usuario"
                                :items="sectionsUser"
                                item-text="descricao"
                                item-value="id"
                                :rules="[form_usuario_rules.required]"
                            ></v-autocomplete>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="4"
                        >
                            <v-autocomplete
                                label="Nome do Registro"
                                v-model="form.id_pessoa"
                                :items="sectionsPeople"
                                item-text="descricao"
                                item-value="id"
                                :rules="[form_pessoa_rules.required]"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    color="indigo darken-1"
                    dark
                   @click.prevent="save()"
                >
                    <v-icon>
                        mdi-save
                    </v-icon>

                    Salvar
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    color="pink darken-1"
                    dark
                    @click.prevent="returnRead()"
                >
                    <v-icon>
                        mdi-block
                    </v-icon>

                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular
                size="100"
                color="indigo darken-1"
            >
            </v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
import router from '../../router'
export default {
    name: 'vwuserCreate',
    data(){
        return {
            overlay: false,
            show1: false,
            form: {
                login: '',
                senha: '',
                email_recuperacao: '',
                id_tipo_usuario: null,
                id_pessoa: null
            },
            alert: {
                show: false,
                type: 'indigo',
                text: ''
            },
            alertSuccess: {
                show: false,
                type: 'indigo',
                text: ''
            },

            sectionsUser: [],

            sectionsPeople: ['1', '2', '3', '4'],

            form_login_rules: {
                required: value => !!value || 'Usuario é obrigatório.',
                counter: value => value.length <= 16 || 'Dados inválido!',
                min: v => v.length >= 2 || 'Mínimo de 2 caracteres'
            },

            form_senha_rules: {
                required: value => !!value || 'Senha é obrigatória.',
                min: v => v.length >= 8 || 'Mínimo de 8 caracteres'
            },

            form_email_rules: {
				required: value => !!value || 'Email obrigatório.',
				counter: value => value.length <= 64 || 'Email inválido',
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					return pattern.test(value) || 'E-mail inválido.'
				}
			},

            form_usuario_rules: {
                required: value => !!value || 'Selecione o tipo de usuario.'
            },

            form_pessoa_rules: {
                required: value => !!value || 'Selecione o registro da pessoa.'
            }
        }
    },

    computed:{
        id: function(){
            return this.$route.params.id
        }
    },

    methods: {
        clearForm: function() {
            for (let prop in this.form) {
                this.form[prop] = ''
            }
        },

        returnRead: function() {
            router.push({ name: 'user.read' })
        },
    
        save: function(){
            if(this.$refs.form.validate()){
                this.overlay = true
                if(this.id !== undefined){
                    this.update()
                }else{
                    this.create()
                }
            }
        },

        update: function(){
            this.overlay = true
            fetch(process.env.VUE_APP_API + '/user/update/' + this.id, {
                method: 'PUT',
                headers: new Headers({
                    'Authentication': this.$store.getters.token,
                    'Data': JSON.stringify(this.form)
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.clearForm()
                    this.returnRead()
                })
                .catch(error => {
                    console.error(error)
                    this.alert = {
                        text: 'Erro interno ao atualizar o usuario!',
                        show: true,
                        type: 'red darken-1'
                    }
                })
                .finally(() => {
                    this.overlay = false
                })
        },

        create: function(){
            this.overlay = true
            fetch(process.env.VUE_APP_API + '/user/create', {
                method: 'POST',
                headers: new Headers({
                    'Authentication': this.$store.getters.token,
                    'Data': JSON.stringify(this.form)
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.alertSuccess = {
                        text: 'Usuario cadastrado com sucesso.',
                        show: true,
                        type: 'red darken-1'
                    }
                    this.clearForm()
                })
                .catch(error => {
                    console.error(error)
                    this.alert = {
                        text: 'Erro interno ao gravar o usuario!',
                        show: true,
                        type: 'red darken-1'
                    }
                })
                .finally(() => {
                    this.overlay = false
                })
        },

        getData: function(){
            this.overlay = true
            fetch(process.env.VUE_APP_API + '/user/read/' + this.id, {
                method: 'GET',
                headers: new Headers({
                    'Authentication': this.$store.getters.token
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.form = resJSON.response[0].listhelper[0]
                })
                .catch(error => {
                    console.error(error)
                })
                .finally(() => {
                    this.overlay = false
                })
        },

        getSections: function(){
            fetch(process.env.VUE_APP_API + '/generics/description/usuarios_tipo', {
                method: 'GET',
                headers: new Headers({
                    'Authentication': this.$store.getters.token
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.sectionsUser = resJSON.response
                })
                .catch(error => {
                    console.error(error)
                })
        },

        getSectionsPeople: function(){
            fetch(process.env.VUE_APP_API + '/generics/description/people', {
                method: 'GET',
                headers: new Headers({
                    'Authentication': this.$store.getters.token
                })
            })
                .then(res => res.json())
                .then(resJSON => {
                    console.log(resJSON)
                    this.sectionsPeople = resJSON.response
                })
                .catch(error => {
                    console.error(error)
                })
        }
    },

    mounted(){
        if (this.id != undefined) {
            this.getData()
        }

        this.getSections()

        // this.getSectionsPeople()
    }
}
</script>